import { Excess, Excesses } from '../../types/policyTypes';
import { DetailsWidget } from './detailsWidget';
import { TableWidget } from './tableWidget';

interface CreatePolicyWidgetCardProps {
  body: string | null;
  heading: JSX.Element;
  policyItemDetails?: JSX.Element | null;
}

export interface WidgetItem {
  description: string | JSX.Element;
  isHtml?: boolean;
  name: string;
  key?: string;
}

export interface CreateDetailsCardProps {
  items: WidgetItem[];
  heading: JSX.Element;
  body: string;
  eventKey?: string;
  className?: string;
}

export function createPolicyWidgetCard({
  heading,
  body,
  policyItemDetails = null
}: CreatePolicyWidgetCardProps): JSX.Element {
  return (
    <div className="policy-widget-card">
      {heading}
      {body && <span className="policy-widget-text">{body}</span>}
      <div className="policy-item-details">{policyItemDetails}</div>
    </div>
  );
}

export function createDetailsCard({ items, heading, body, eventKey, className }: CreateDetailsCardProps): JSX.Element {
  const widgets = items.map((item, index) => {
    const { name, description, isHtml } = item;
    const body = isHtml ? description : <div dangerouslySetInnerHTML={{ __html: description as string }}></div>;
    return <DetailsWidget key={index} heading={name} body={body} eventKey={eventKey} className={className} />;
  });
  return createPolicyWidgetCard({
    heading,
    body,
    policyItemDetails: <>{widgets}</>
  });
}

export function createExcessesTables(
  excesses: Excesses,
  compulsoryExcessesTableHeaders: string[],
  voluntaryExcessesTableHeaders: string[]
): { compulsoryExcessesTable: JSX.Element; voluntaryExcessesTable: JSX.Element | null } {
  const { compulsoryExcesses, voluntaryExcesses } = excesses;
  const compulsoryExcessesTable = (
    <TableWidget headerNames={compulsoryExcessesTableHeaders} rows={createExcessesRows(compulsoryExcesses)} />
  );

  let voluntaryExcessesTable: JSX.Element | null = null;

  if (voluntaryExcesses.length) {
    voluntaryExcessesTable = (
      <TableWidget headerNames={voluntaryExcessesTableHeaders} rows={createExcessesRows(voluntaryExcesses)} />
    );
  }

  return { compulsoryExcessesTable, voluntaryExcessesTable };
}

export function createExcessesRows(excesses: Excess[]): string[][] {
  const excessesRows: string[][] = [];
  for (const excess of excesses) {
    const row = [excess.description, `£${excess.amount}`];
    excessesRows.push(row);
  }

  return excessesRows;
}
